import './FormPopup.scss';
import { useCallback, useRef, PropsWithChildren, useEffect } from 'react';
import ValidationSummary from 'devextreme-react/validation-summary';
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import ValidationGroup from 'devextreme-react/validation-group';
import { useScreenSize } from '../../../utils/media-query';
import { Button, LoadIndicator } from 'devextreme-react';
import { formatMessage } from 'devextreme/localization';

type PopupProps = {
  title: string;
  visible: boolean;
  width?: number;
  wrapperAttr?: { class: string };
  isSaveDisabled?: boolean;
  setVisible: () => void;
  onSave?: () => void;
  loading: boolean;
  allowSave:boolean
};

export const FormPopup = ({ title, visible, width = 500, setVisible, onSave, wrapperAttr = { class: '' }, isSaveDisabled = false, children, loading = false, allowSave }: PropsWithChildren<PopupProps>) => {
  const { isXSmall } = useScreenSize();
  const validationGroup = useRef<ValidationGroup>(null);
  useEffect(() => {
    if (visible) {
      validationGroup.current?.instance.reset();
    }
  }, [visible]);

  const close = () => {
    validationGroup.current?.instance.reset();
    setVisible();
  };

  const onCancelClick = useCallback(() => {
    close();
  }, [close, validationGroup]);

  const onSaveClick = () => {
    if (!validationGroup.current?.instance.validate().isValid) return;
    onSave && onSave();
  };

  return (
    <Popup title={title} visible={visible} showCloseButton={true} onHiding={onCancelClick} fullScreen={isXSmall} width={width} wrapperAttr={{ ...wrapperAttr, class: `${wrapperAttr?.class} form-popup` }} height='auto'>
      <ToolbarItem toolbar='bottom' location='center'>
        <div className={`form-popup-buttons-container ${width <= 360 ? 'flex-buttons' : ''}`}>          
          <Button stylingMode='contained' type={loading ? 'normal' : 'default'} disabled={isSaveDisabled || allowSave} onClick={onSaveClick}>
            <div style={{ padding: 8 }}>
              <span className='dx-button-text' style={{ marginRight: loading ? 10 : 0 }}>
                {loading ? formatMessage('SavingButton') : formatMessage('saveButton')}
              </span>
              <LoadIndicator className='button-indicator' height={15} width={15} style={{ marginLeft: 20, marginRigth: 20 }} visible={loading} />
            </div>
          </Button>
        </div>
      </ToolbarItem>
      <ValidationGroup ref={validationGroup} id='ValidationForm'>
        {children}
        <ValidationSummary id='ValidationForm' />
      </ValidationGroup>
    </Popup>
  );
};
